import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { Select, Skeleton } from 'antd';
import { ISubcode } from '../../models/codes.model';

interface IMonthSelect {
  month: number;
  setMonth: (month: number) => void;
  numberOnly?: boolean;
  className?: string;
  disabled?: boolean;
}

const MonthSelect = ({ month, setMonth, numberOnly = false, className = '', disabled = false }: IMonthSelect) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);

  // commonCodes 로딩 이후 컴포넌트가 생성 된다.
  if (!commonCodes || !(commonCodes.length > 0)) {
    return <Skeleton.Button active={true} size={'default'} shape={'default'} block={false} />;
  }
  // SY0009 = 월 정보
  const SY0009 = commonCodes.find(
    (item) => item.commonCode === 'SY0009',
  )?.detailCode;

  if (!SY0009 || SY0009.length <= 0) {
    return <Skeleton.Button active={true} size={'default'} shape={'default'} block={false} />;
  }

  return (
    <Select
      className={className}
      value={month}
      onChange={value => setMonth(value)}
      disabled={disabled}
    >
      {
        SY0009.map((item: ISubcode) => {
          return (
            <Select.Option
              style={{
                width: 'fit-content',
              }}
              key={item.detailCode}
              value={item.detailCode}
            >
              {numberOnly ? item.datailCode : item.korName}
            </Select.Option>
          )
        })
      }
    </Select>
  )
}

export default MonthSelect;